/**
 * @author Ariel
 * @date 2020-09-08
 * @desc 帖子管理列表页配置
 */
import React from 'react'
import {WizTableForm} from '../../../common'
import {component_tool} from '../../../../tool'

let {WizDataTable, WizButton, WizModal} = component_tool
const topicConfig = WizTableForm.Config.topic(this)

let componentName = 'invitation'

const columns = (e) => {
  let {topic, defaultParams} = e
  let topicProps = {}
  if (topic && topic.id) {
    topicProps.initialValue = [topic.id]
    topicProps.initRows = [topic]
  }
  let transfer = defaultParams && defaultParams.transfer
  if (transfer && transfer.id) {
    topicProps.initialValue = transfer.topicId
    topicProps.initRows = [{id: transfer.topicId,title: transfer.topicName}]
  }
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '账号',
      name: 'userName',
      tableItem: {
        width: 150
      }
    },
    {
      title: '姓名',
      name: 'fullName',
      tableItem: {
        width: 150
      }
    },
    {
      title: '用户昵称',
      name: 'nickName',
      tableItem: {
        width: 150
      }
    },
    {
      title: '所属话题',
      name: 'topicName',
      tableItem: {
        width: 150,
      },
    },
    {
      title: '所属话题',
      name: 'topicId',
      searchItem: {
        ...topicConfig,
        diy: WizTableForm,
        selectType: 'radio',
        ...topicProps
      }
    },
    {
      title: '帖子内容',
      name: 'content',
      tableItem: {
        ellipsis: true,
        width: 200
      },
      searchItem: {
        initialValue: transfer && transfer.content
      },
    },
    {
      title: '帖子类型',
      name: 'type',
      tableItem: {width: 100},
      searchItem: {
        type: 'select',
        initialValue: transfer && transfer.type
      },
      dict: [
        {code: 0, codeName: '文本'},
        {code: 1, codeName: '图片'},
        {code: 2, codeName: '视频'}
      ]
    },
    {
      title: '帖子来源',
      name: 'sourceType',
      tableItem: {width: 100},
      searchItem: {
        type: 'select',
        initialValue: transfer && transfer.sourceType
      },
      dict: [
        {code: 0, codeName: '原创'},
        {code: 1, codeName: '转发'},
        {code: 2, codeName: '分享'}
      ]
    },
    {
      title: '点赞量',
      name: 'agreeCount',
      tableItem: {
        width: 100,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton
              tooltip={text}
              onClick={() => {
                e.jumpPage && e.jumpPage(
                  'push',
                  '/interact/community/invitation/invitationAgree',
                  {searchProps: {invitation: record}}
                )
              }}>
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: '点踩量',
      name: 'stepCount',
      tableItem: {
        width: 100,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton
              tooltip={text}
              onClick={() => {
                e.jumpPage && e.jumpPage(
                  'push',
                  '/interact/community/invitation/invitationStep',
                  {searchProps: {invitation: record}}
                )
              }}
            >
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: '转发量',
      name: 'transpondCount',
      tableItem: {
        width: 100,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton
              tooltip={text}
              onClick={() => {
                e.jumpPage && e.jumpPage(
                  'push',
                  '/interact/community/invitation/invitationTranspond',
                  {searchProps: {invitation: record}},
                  { search: { id: record.id } }
                )
              }}
            >
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: '评论量',
      name: 'commentCount',
      tableItem: {
        width: 100,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton
              tooltip={text}
              onClick={() => {
                e.jumpPage && e.jumpPage(
                  'push',
                  '/interact/community/invitation/invitationComment',
                  {searchProps: {invitation: record, btnAccessCheck: false,}}
                )
              }}
            >
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: '热门置顶',
      name: 'popularTop',
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: '否'},
        {code: 1, codeName: '是'},
      ]
    },
    {
      title: '发帖时间',
      name: 'createTime',
      tableItem: {width: 200}
    }
  ]
}

const templateConfig = (e) => {
  let {btnAccessCheck} = e
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(e),
        btnAccessCheck: btnAccessCheck,
        searchBarProps: {
          // collapse: false,
          buttonSort: ['add', 'delete', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/interact/community/invitation/invitationDetailAdd',
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          selectType: 'checkbox',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look', 'topicEnable', 'popularTopOrCancelPopularTop'],
        rowOperateView: [
          {
            key: 'look',
            custom: true,
            params: {children: '查看'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/interact/community/invitation/invitationLook'
              }
            }
          },
          {
            key: 'topicEnable',
            custom: true,
            params: {children: '话题置顶'},
            textFormat: {
              recordKey: 'topicTop',
              dirt: {'1': '取消话题置顶', '0': '话题置顶',}
            },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'topicEnable',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['topicTop'] === 0 ? '话题置顶' : '取消话题置顶'
                }该帖子吗？`
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      topicTop: record['topicTop'] === 0 ? 1 : 0,
                      id: record['id'],
                      ...filters
                    })
                  },
                  onCancel() {
                  }
                })
                return null
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = true
              if (record && record['topicId'] && record['topicId'] > 0) {
                disabled = false
              }
              return {disabled}
            }
          },
          {
            key: 'popularTopOrCancelPopularTop',
            custom: true,
            params: {children: '热门置顶'},
            textFormat: {
              recordKey: 'popularTop',
              dirt: {'1': '取消热门置顶', '0': '热门置顶',}
            },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'popularEnable',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['popularTop'] === 0 ? '热门置顶' : '取消热门置顶'
                }该帖子吗？`
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      popularTop: record['popularTop'] === 0 ? 1 : 0,
                      id: record['id'],
                      ...filters
                    })
                  },
                  onCancel() {
                  }
                })
                return null
              }
            }
          },
        ]
      }
    }
  }
}

const apis = (defaultParams = {}) => {
  let {transferId, topicId,transfer} = defaultParams
  let topicInfoId = transfer && transfer.topicId && transfer.topicId > 0 ? transfer.topicId : ''
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: { transferId: transferId || [], topicId: topicId || topicInfoId || null }
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    },
    topicEnable: {
      path: `${componentName}/topicEnable`,
      payload: {
        key: `${componentName}@topicEnable`,
        apiParams: {}
      }
    },
    popularEnable: {
      path: `${componentName}/popularEnable`,
      payload: {
        key: `${componentName}@popularEnable`,
        apiParams: {}
      }
    }
  }
}

let reduxTemplateConfig = (args) => {
  let {defaultParams, ...rest} = args
  return {
    apis: apis(defaultParams),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...rest
  }
}

export {reduxTemplateConfig, templateConfig}
